import { Image } from "antd";
import { IMAGE_NOT_FOUND } from "constants/common";
import { FC } from "react";
import { useGetImageUrl } from "services/image";
import { getImageFullPath, isDigitalOceanImage } from "utils/image";

interface IImageAuthen {
  url: string;
}

const ImageAuthen: FC<IImageAuthen> = ({ url }) => {
  const { imageUrl } = useGetImageUrl(url);
  const commonProps = {
    height: 80,
    width: 80,
    className: "object-contain",
    fallback: IMAGE_NOT_FOUND,
  };
  if (!url) {
    return <Image src={IMAGE_NOT_FOUND} {...commonProps} />;
  }

  return (
    <Image
      src={isDigitalOceanImage(url) ? imageUrl : getImageFullPath(url)}
      {...commonProps}
    />
  );
};

export default ImageAuthen;
